import classNames from "classnames";
import { Link } from "react-router-dom";

const AvailableTime = ({ _id, event, setEvent, time, ticketsRemaining, inCart, waitlisted, onToggleWaitlist, waitlistLoading, isAuthenticated }) => {
    const soldOut = ticketsRemaining < 1

    return (
        <div
            onClick={!soldOut ? () => setEvent(_id) : null}
            className={classNames(
                "flex justify-between items-center gap-3 pl-4 p-2 border rounded-md transition",
                inCart ? "border-primary bg-blue-50 shadow-sm" : "border-borderGrey",
                event === _id && !inCart ? "border-primary" : "",
                soldOut ? "" : "cursor-pointer"
            )}
        >
            <div>
                <p>{time}</p>
                {inCart && <p className={"text-xs text-primary font-semibold mt-1"}>In cart</p>}
                {waitlisted && <p className={"text-xs text-primary font-semibold mt-1"}>Waitlisted</p>}
            </div>
            {soldOut ? (
                isAuthenticated ? (
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggleWaitlist(_id);
                        }}
                        disabled={waitlistLoading}
                        className={classNames(
                            "border-0 block md:inline-block px-3 py-2 rounded-md text-center",
                            waitlisted ? "bg-primary text-white" : "bg-backgroundGrey"
                        )}
                    >
                        {waitlistLoading ? 'Updating...' : waitlisted ? 'Leave waitlist' : 'Join waitlist'}
                    </button>
                ) : (
                    <Link
                        to={`/login?referer=${encodeURIComponent(window.location.href)}`}
                        onClick={(e) => e.stopPropagation()}
                        className={"border-0 block md:inline-block px-3 py-2 rounded-md text-center bg-backgroundGrey"}
                    >
                        Join waitlist
                    </Link>
                )
            ) : (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        setEvent(_id);
                    }}
                    disabled={event === _id}
                    className={classNames(
                        "border-0 block md:inline-block px-3 py-2 rounded-md text-center",
                        inCart ? "bg-primary text-white" : "bg-backgroundGrey"
                    )}
                >
                    {inCart ? 'In cart' : event === _id ? 'Selected' : 'Select'}
                </button>
            )}
        </div>
    )
}

export default AvailableTime
